import React from 'react';
import { getUserCustomer } from 'selectors/auth';
import { getIntegrationSettings } from 'selectors/integrationSettings';
import { useSelector } from 'store';
import { useCasesOptions } from '../EditIntegrationSettings/IntegrationSettingsUseCases';

const ImportSideSection: React.FC = () => {
  const integrationSettings = useSelector(getIntegrationSettings);
  const customer = useSelector(getUserCustomer);

  return (
    <div className="w-2/5 pl-10 pt-10 h-full flex flex-col gap-4 text-body bg-white">
      <span className="text-heading-3">Integration Settings</span>
      {integrationSettings ? (
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-1">
            <p>
              Legal hold: <b>{integrationSettings.legal_hold ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Email and chat retention policy:{' '}
              <b>{integrationSettings.email_chat_retention_policy || 'None'}</b>
            </p>
            <p>
              LitLingo retention policy:{' '}
              <b>{customer?.config?.communication_retention_days || 0} days</b>
            </p>
          </div>
          <p>
            Use Cases:{' '}
            <b>
              {integrationSettings.use_case_uuids
                .map((u) => useCasesOptions.find((us) => us.value === u)?.label)
                .join(',')}
            </b>
          </p>
          <div className="flex flex-col gap-1">
            <p>
              Translations needed: <b>{integrationSettings.translations_needed ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Additional language offerings (besides English) needed for Prevent:{' '}
              <b>{integrationSettings.additional_language_offerings ? 'Yes' : 'No'}</b>
            </p>
            <p>
              Languages for a better Prevent experience:{' '}
              <b>{integrationSettings.languages_for_better_prevent}</b>
            </p>
          </div>
        </div>
      ) : (
        <div className="">Integration settings not defined</div>
      )}
    </div>
  );
};

export default ImportSideSection;
